import React from "react";
import { Select, Form } from "antd";
import { Input, Button } from "antd-mobile";
import { withLocalize } from "react-localize-redux";


const { Option } = Select;

const masalik = [
  "any",
  "deobandi",
  "ahlehadees",
  "barelvi",
];

const SearchModal = ({ translate, setParams, setVisible }) => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    let city = localStorage.getItem("city");
    let latitude = parseFloat(localStorage.getItem("latitude"));
    let longitude = parseFloat(localStorage.getItem("longitude"));


    let data = {
      city: city,
      latitude: latitude,
      longitude: longitude,
      name: values.name || null,
      range: parseFloat(values.range),
      maslak: values.maslak,
    };

    console.log(data);
    setParams(data);
    setVisible(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          range: "1",
          maslak: "any",
          name: "",
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label={translate("range")}
          rules={[
            {
              required: true,
            },
          ]}
          name="range"
        >
          <Select style={{ width: "100%" }}>
            <Option value="1">1 KM</Option>
            <Option value="2">2 KM</Option>
            <Option value="3">3 KM</Option>
            <Option value="4">4 KM</Option>
            <Option value="5">5 KM</Option>
          </Select>
        </Form.Item>
        <Form.Item label={translate("maslak")} name="maslak">
          <Select style={{ width: "100%" }}>
            {masalik.map((maslak, index) => {
              return (
                <Option value={maslak} key={"maslak-" + index}>
                  {translate(maslak)}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item label={translate("masjid_name")} name="name">
          <Input style={{ border: "1px solid #d9d9d9" }} />
        </Form.Item>
        <Button color="primary" block onClick={() => form.submit()}>
          {translate("search")}
        </Button>
      </Form>
    </div>
  );
};

export default withLocalize(SearchModal);
